<template>
  <div id="communityDetail" class="communityDetail">
    <goodsInfo
        ref="goodsInfon"
        :Slash="true"
        :back="back"
        :buttonTest="buttonTest"
        :goodsParams="goodsImgs"
        :point="true"
        :state="!!goodsImgs.skuId"
        :swiperArr="detailInfo.contentImg || []"
        class="goodsInfo"
        from="communityDetail"
        @goBack="goBack"
    ></goodsInfo>
    <div class="content">
      <div class="content-title">{{ this.detailInfo.title }}</div>
      <div class="content-user">
        <img :src="detailInfo.headImg" alt=""/>
        {{ detailInfo.nickName }}
      </div>
      <div class="content-details" v-html="detailInfo.content"></div>
    </div>
    <new-comment-field
        ref="focus"
        :articalId="detailInfo.contentId"
        :detailInfo="detailInfo"
        :isGoLogin="isUserLogin()"
        :module="1"
        :title="detailInfo.title"
        @changeCommentNum="changeCommentNum"
        @getAllComment="getAllComment"
        @isLogin="globalGoLogin"
        @sensorsFn="sensorsFn"
    >
    </new-comment-field>
    <new-all-comment
        ref="allComment"
        :articalId="detailInfo.contentId"
        :isGoLogin="isUserLogin()"
        :module="1"
        :title="detailInfo.title"
        @changeCommentNum="changeCommentNum"
        @focusOn="getFocusOn"
        @sensorsFn="sensorsFn"
        @type="getType"
    ></new-all-comment>
    <audioShare ref="share"></audioShare>
  </div>
</template>
<script>
import {gainReady, getCookie, globalGoLogin, isUserLogin,} from '@/assets/js/common.js'
//头部返回组件
import Back from '@/components/common/goBack'
import goodsInfo from '@/components/contents/trialProductsList/goodsInfo.vue'
import newAllComment from '@/newComponents/comment/allComment.vue'
import newCommentField from '@/newComponents/comment/commentField.vue'
import {
  xmhh5CommunityallPageView,
  Xmhh5CommunityArticleResult,
  xmhh5CommunityClick_fn,
  xmhh5CommunityGoodsExpo,
} from '@/assets/js/BuriedPointEvent'
import audioShare from '@/components/comment/share.vue'
import wx from 'weixin-js-sdk'

export default {
  name: 'communityDetail',
  data() {
    return {
      activeIndex: 0,
      sensorsIndex: 0,
      goodsImgs: {},
      detailInfo: {},
      carrierId: 10,
      userInfo: {},
      back: require('@/assets/images/community/back-commutil.png'),
      buttonTest: `立即查看<img class='img' src=${require('@/assets/images/community/arrow.png')} alt="" />`,
    }
  },
  components: {
    Back,
    goodsInfo,
    newAllComment,
    newCommentField,
    audioShare,
  },
  created() {
    this.userInfo = !this.isUserLogin()
        ? JSON.parse(localStorage.getItem('userInfo'))
        : {}
    this.getContentById()
    console.log(this.$refs.goodsInfo, 'this.$refs.goodsInfo')
  },
  mounted() {
  },
  methods: {
    globalGoLogin,
    isUserLogin,
    gainReady,
    goBack() {
      this.gainReady(null, () => {
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.replace('/communityIndex')
        }
      })
    },
    changeCommentNum(state) {
      state ? this.detailInfo.commentNum++ : this.detailInfo.commentNum--
    },
    getAllComment() {
      this.$refs.allComment.getAllComment(this.$refs.allComment.hotOrNew)
      console.log(this.$refs.goodsInfon, 'this.$refs.goodsInfo')
    },
    // 判断 当前页面的环境
    setgain(callback) {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            callback && callback(1)
          } else {
            callback && callback(2)
          }
        })
      }
    },
    getContentById() {
      console.log(111, '111')
      this.$http.get(
          '/seeding/queryContentById',
          {
            contentId: this.$route.params.id,
            crmId: this.userInfo?.crm_id || getCookie('xmh_unionid'),
          },
          (res) => {
            if (res.code == 200 && res.data != null) {
              const {beforeUrl, beforeName, productId, skuId, title} = res.data
              this.detailInfo = res.data
              console.log(this.detailInfo, 'this.detailInfo')
              this.goodsImgs = {
                img: beforeUrl,
                title:
                    beforeName && beforeName.length > 20
                        ? beforeName.slice(0, 21)
                        : beforeName,
                productId: productId,
                skuId: skuId,
                id: this.$route.params.id,
                contentImg: this.detailInfo.contentImg[0],
                watchNum: this.detailInfo.watchNum,
                detaliTitle: title,
              }
              console.log(this.goodsImgs, 'goodsImgs')
              setTimeout(() => {
                this.sharePage(this.goodsImgs.contentImg)
              }, 200)
              console.log(this.goodsImgs.detaliTitle, 'contentImg')
              this.$nextTick(() => {
                // 页面浏览度曝光
                this.setgain((value) => {
                  xmhh5CommunityallPageView.observe(
                      'xmhh5CommunityallPageView',
                      '.content-title',
                      false,
                      {
                        xmhh5_Community_Article_Title: this.goodsImgs.detaliTitle,
                        xmhh5_Community_Article_Source:
                            value === 1 ? '星妈优选小程序' : '星妈会h5',
                      }
                  )
                  Xmhh5CommunityArticleResult.observe(
                      'Xmhh5CommunityArticleResult',
                      '.wrap',
                      false,
                      {
                        is_finished: true,
                      }
                  )
                })

                // 商品标题曝光 文章标题曝光
                xmhh5CommunityGoodsExpo.observe(
                    'xmhh5CommunityGoodsExpo',
                    '.test-goods-title',
                    false,
                    {
                      xmhh5_Community_goods_Expo: this.goodsImgs.title,
                      xmhh5_Community_Article_Expo: this.goodsImgs.detaliTitle,
                    }
                )
              })
            } else {
              if (res.code == 201) {
                sessionStorage.setItem('hasDelete', true)
                this.$toast({
                  message: '文章已被删除，看看其他的吧~',
                  duration: 2000,
                })
                setTimeout(() => {
                  this.goBack()
                }, 500)
              } else {
                this.$toast({
                  message: res.message,
                  duration: 2000,
                })
              }
            }
          },
          (err) => {
            // console.log(err, "000000000-------------");
          },
          'lucky'
      )
    },
    // 分享
    sharePage(img) {
      var shareDataParams = {
        shareLink: location.href.split('#')[0],
        shareDesc: `星妈会${this.goodsImgs.watchNum}人浏览的火热动态，快来看看吧～`,
        shareTitle: this.goodsImgs.detaliTitle,
        imgUrl: img, //必须是绝对路径
      }
      console.log(shareDataParams, 'shareDataParams')
      this.wxJsSet.wxShare('fx', shareDataParams, this)
    },

    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool
    },
    getType(type) {
      this.$refs.focus.type = type
    },
    // 滑动到评论的埋点
    sensorsFn(clickType) {
      xmhh5CommunityClick_fn('xmhh5CommunityClick', {
        xmhh5_Community_details_Click: clickType,
      })
    },
  },
  computed: {
    // 截取20字加省略号
    // content: "<div class='title'>文章标题111</div><div class='content'>文章内容文章内容文章内容文章内容文章内容文章内容文章内容</div>"
    str() {
      let str = this.detailInfo.title || '' // .substr(0,20)
      return str.length > 20 ? str.substr(0, 20) + '...' : str
    },
  },
}
</script>
<style lang="less">
.communityDetail {
  background: #fff;
  position: relative;

  .back {
    position: absolute;
    left: 0;
    top: 0px;
    z-index: 999;
    overflow: hidden;

    img {
      width: 0px;
      margin-left: 0px;
    }
  }

  .goodsInfo {
    .custom-indicator {
      position: absolute;
      right: 0.29333rem;
      top: 14px;
      background: #000000;
      width: 36px;
      height: 24px;
      border-radius: 14px;
      opacity: 0.6;
      color: #fff;

      .active-numbers {
        background: transparent;
        padding: 0px 4px;
        opacity: 1;
      }

      .total-numbers {
        background: transparent;
        padding: 0px;
        opacity: 1;
      }

      .Slash {
        padding-right: 3px;
        align-items: center;
      }
    }

    .test-goods-container {
      .van-swipe {
        .van-swipe-item {
          height: 500px;
          background: #d8d8d8;
          display: flex;
          align-items: center;

          img {
            // height: 500px;
          }
        }
      }
    }

    .go-back {
      img {
        width: 26px;
        height: 26px;
        top: 6px;
        left: 6px;
      }
    }

    .test-goods-introduction {
      // display: flex;
      height: 62px;
      padding: 0px 0px;
      margin: 0 12px;
      padding-bottom: 11px;
      border-bottom: 1px solid #f9f9f9;
      border-radius: 0px;

      .test-goods-imgs {
        width: 50px;
        height: 50px;
        margin-top: 10px;

        img {
          width: 50px;
          height: 50px;
          border-radius: 0px;
        }
      }

      .test-goods-jump {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff4892;
        padding-top: 0;
        width: 62px;
        height: 16px;
        border-radius: 8px;
        border: 1px solid #ffe3ec;
        text-align: center;
        line-height: 16px;
        position: relative;
        margin-top: 6px;

        .img {
          width: 5px;
          height: 9px;
          position: absolute;
          left: 53px;
          top: 4px;
        }
      }

      .test-goods-detail {
        .test-goods-title {
          width: 295px;
          height: auto;
          line-height: 25px;
          padding-top: 10px;
          -webkit-line-clamp: 1;
          overflow: hidden !important; //溢出内容隐藏
          text-overflow: ellipsis !important; //文本溢出部分用省略号表示
          //-webkit-box-orient: vertical; //盒子中内容竖直排列
          display: -webkit-box !important; //特别显示模式
          line-clamp: 1;
          word-break: break-all;
        }
      }
    }
  }

  .content {
    .content-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin: 12px 13px 0 13px;
    }

    .content-user {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin: 12px 0 0 12px;
      vertical-align: middle;

      img {
        width: 24px;
        height: 24px;
        background: #e6d6c8;
        border-radius: 50%;
        vertical-align: middle;
      }
    }

    .content-details {
      margin: 25px 12px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 26px;

      .trim-row {
        height: 25px;
      }

      .bold {
        font-weight: 600;
      }
    }
  }
}
</style>
